import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Container, Row, Col, Table} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FetchAllDoctorRecords } from "src/Thunk/adminThunks";
const MySwal = withReactContent(Swal);

const DoctorList = () => {
  const dispatch = useDispatch();
  const { doctorList } = useSelector((state) => state.admin);
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  let itemsPerPage = 10;

  useEffect(() => {
    dispatch(FetchAllDoctorRecords());
  }, []);

  const filteredDoctors = doctorList.filter((customer) =>
    Object.values(customer).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDoctors.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="main-content">
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 text-info">DOCTOR INFORMATION LIST</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Home</Link>
                    </li>
                    <li className="breadcrumb-item text-info active">
                      Doctor Info List
                    </li>
                  </ol>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="card custom-shadow rounded-lg border my-3">
                <div className="card-body">
                  <Row>
                    <Col md={4} xs={12} className="mb-3 text-center">
                      <h3 className="fw-bolder text-info mb-0">
                        {doctorList.length}
                      </h3>
                      <p className="text-secondary">
                        Total Recorded Doctor Information
                      </p>
                    </Col>
                  </Row>

                  <div className="dataTables_length mb-2">
                    <div className="search-box">
                      <input
                        type="text"
                        id="search"
                        placeholder="Search "
                        name="search"
                        className="form-control "
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Table responsive bordered22 hover>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Gender</th>
                          <th>Clinic Address</th>
                          <th>Mobile No</th>
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems?.map((doctor) => (
                          <tr key={doctor?._id}>
                            <td>{doctor?.Name}</td>
                            <td>{doctor?.Email}</td>
                            <td>{doctor?.Gender}</td>
                            <td>
                              {doctor?.Address.substring(0, 25) + "......"}
                            </td>
                            <td>{doctor?.PhoneNumber}</td>
                            <td>
                              <div className="icon-container">
                                <Link
                                  className="btn btn-sm btn-info text-white"
                                  state={doctor}
                                  title="view doctor info"
                                  to={`/doctorDetails/${doctor._id}`}
                                >
                                  <FontAwesomeIcon icon={faEye} />
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <Container>
                    <div className="col-sm-12 col-md-5">
                      <div className="dataTables_length">
                        Showing {indexOfFirstItem + 1} to{" "}
                        {Math.min(indexOfLastItem, doctorList.length)} of{" "}
                        {doctorList.length} entries
                      </div>
                    </div>
                    <div>
                      {Array.from({
                        length: Math.ceil(doctorList.length / itemsPerPage),
                      }).map((_, index) => (
                        <button
                          key={index}
                          type="button"
                          className="btn btn-primary btn-circle btn-sm text-white m-1"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      ))}
                    </div>
                  </Container>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default DoctorList;
